import { useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function useSectionReveal(ref, options = {}) {
  useLayoutEffect(() => {
    const el = ref?.current;
    if (!el) return undefined;

    const reduceMotion =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      gsap.set(el, { opacity: 1, y: 0, clearProps: 'transform' });
      return undefined;
    }

    const ctx = gsap.context(() => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 18 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          ease: 'power2.out',
          clearProps: 'transform',
          scrollTrigger: {
            trigger: el,
            start: options.start ?? 'top 82%',
            once: options.once ?? true,
          },
        }
      );
    }, el);

    return () => {
      ctx.revert();
    };
  }, [ref, options.start, options.once]);
}

